// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#qfLogo {\n    width: 30px;\n}\n\n#yosysSVGDiv svg {\n    width: 100%;\n    height: inherit;\n}\n\n.inputCircle {\n    background-color: #89da8f;\n    width: 15px;\n    border-radius: 50%;\n    display: inline-block;\n    text-align: center;\n    color: white;\n    font-size: 10px;\n}\n\n.outputCircle {\n    background-color: rgb(239 168 168);\n    width: 15px;\n    border-radius: 50%;\n    display: inline-block;\n    text-align: center;\n    color: white;\n    font-size: 10px;\n}", ""]);
// Exports
module.exports = exports;
